export const PROJECT_REFRESH_INTERVAL_MS = 30 * 1000;
